import { appLinkTreesObject } from "@megarax/links";

/** Human-readable name of the app that owns a signal, falling back to the raw app id. */
export const signalAppLabel = (app: string): string => appLinkTreesObject[app]?.name ?? app;
